import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';

@Component({
  selector: 'app-plan-error',
  templateUrl: './plan-error.component.html',
  styleUrls: ['./plan-error.component.scss']
})
export class PlanErrorComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PlanErrorComponent>,
        public trackingService: TrackingService) {
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
